"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageHandler = exports.TYPE_STORAGE_SESSION = exports.TYPE_STORAGE_LOCAL = void 0;
exports.TYPE_STORAGE_LOCAL = 'local';
exports.TYPE_STORAGE_SESSION = 'session';
var StorageHandler = /** @class */ (function () {
    /**
     * @constructor
     * @param {string} prmName of your global key
     * @param {string} prmType must be session|local
     */
    function StorageHandler(prmName, prmType) {
        if (prmType === void 0) { prmType = exports.TYPE_STORAGE_SESSION; }
        if (StorageHandler.typeValidator(prmType)) {
            this.name = prmName;
            var storageType = prmType === exports.TYPE_STORAGE_SESSION ? sessionStorage : localStorage;
            this.storageType = storageType;
            if (!this.storageType.getItem(prmName)) {
                this.storageType.setItem(this.name, '{}');
            }
        }
        else {
            throw new Error("".concat(prmType, " isn't a valid value ").concat(exports.TYPE_STORAGE_SESSION, "|").concat(exports.TYPE_STORAGE_LOCAL));
        }
    }
    Object.defineProperty(StorageHandler.prototype, "_name", {
        get: function () {
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StorageHandler.prototype, "_storageType", {
        get: function () {
            return this.storageType;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param {String} prmItem name of your item
     * @param {any} prmValue the value associate to your item
     */
    StorageHandler.prototype.set = function (prmItem, prmValue) {
        var _a;
        var storage = this.storageType.getItem(this.name);
        if (storage) {
            var obj = Object.assign(JSON.parse(storage), (_a = {}, _a[prmItem] = prmValue, _a));
            this.storageType.setItem(this.name, JSON.stringify(obj));
        }
    };
    /**
     *
     * @param {String} prmItem name of your item
     * @returns {any | undefined } value of your item
     */
    StorageHandler.prototype.get = function (prmItem) {
        var storage = this.storageType.getItem(this.name);
        if (storage) {
            var obj = JSON.parse(storage);
            return obj[prmItem];
        }
    };
    /**
     *
     * @returns {Object} your storage with all items
     */
    StorageHandler.prototype.getAll = function () {
        var storage = this.storageType.getItem(this.name);
        if (storage) {
            var obj = JSON.parse(storage);
            return obj;
        }
    };
    /**
     *
     * @param {String} prmItem name of your item
     * @param {any} prmValue the value associate to your item
     * @param {number} prmDays number of days before expiration
     */
    StorageHandler.prototype.setWithExpiration = function (prmItem, prmValue, prmDays) {
        var _a;
        if (this.storageType === localStorage) {
            var storage = this.storageType.getItem(this.name);
            if (storage) {
                var obj = Object.assign(JSON.parse(storage), (_a = {},
                    _a[prmItem] = {
                        value: prmValue,
                        expiry: StorageHandler.expirationForLocalStorage(prmDays)
                    },
                    _a));
                this.storageType.setItem(this.name, JSON.stringify(obj));
            }
        }
        else {
            throw new Error('You\'re storage type isn\'t localStorage, can\'t set expiration');
        }
    };
    /**
     *
     * @param {String} prmItem name of your item
     * @returns {any | undefined } value of your item
     */
    StorageHandler.prototype.getWithExpiration = function (prmItem) {
        var storage = this.storageType.getItem(this.name);
        if (storage) {
            var obj = JSON.parse(storage);
            var newObj = obj[prmItem];
            if (newObj.expiry) {
                if (new Date().getTime() > newObj.expiry) {
                    this.remove(prmItem);
                    return undefined;
                }
                return (newObj.value);
            }
            else {
                throw new Error('You\'re key doesn\'t have an expiration, use get method instead');
            }
        }
    };
    /**
     *
     * @param prmItem name of your item
     */
    StorageHandler.prototype.remove = function (prmItem) {
        var storage = this.storageType.getItem(this.name);
        if (storage) {
            var obj = JSON.parse(storage);
            delete obj[prmItem];
            this.storageType.setItem(this.name, JSON.stringify(obj));
        }
    };
    StorageHandler.typeValidator = function (prmType) {
        var validOptions = [exports.TYPE_STORAGE_SESSION, exports.TYPE_STORAGE_LOCAL];
        return validOptions.includes(prmType);
    };
    StorageHandler.expirationForLocalStorage = function (prmDays) {
        var now = new Date().getTime();
        return now + (prmDays * 24 * 60 * 60 * 1000);
    };
    return StorageHandler;
}());
exports.StorageHandler = StorageHandler;
//# sourceMappingURL=storage.js.map